<div *ngIf="event != null" class="call-event-card"
     (click)="callEventClicked.emit(event.id)">
    <div class="call-event-header">
        <div class="call-event-main-info">
            <div class="call-event-status-icon" [ngSwitch]="event.state"
                 [title]="(stateTooltipKeys[event.state] || '') | i18next">
                <svg-icon *ngSwitchCase="CallEventState.ANSWERED" src="assets/icons/ic_event_answered.svg"></svg-icon>
                <svg-icon *ngSwitchCase="CallEventState.MISSED" src="assets/icons/ic_event_missed.svg"></svg-icon>
                <svg-icon *ngSwitchCase="CallEventState.STARTED" src="assets/icons/ic_event_in_progress.svg"></svg-icon>
                <svg-icon *ngSwitchCase="CallEventState.CANCELLED" src="assets/icons/ic_event_canceled.svg"></svg-icon>
                <svg-icon *ngSwitchCase="CallEventState.REJECTED" src="assets/icons/ic_event_rejected.svg"></svg-icon>
                <svg-icon *ngSwitchCase="CallEventState.FORWARDED" src="assets/icons/ic_event_answered.svg"></svg-icon>
                <svg-icon *ngSwitchCase="CallEventState.BRIDGED" src="assets/icons/ic_event_bridged.svg"></svg-icon>
            </div>
            <div class="call-event-info">
                <div class="device-name">
                    <span class="call-direction-icon" [ngClass]="event.isOutgoing ? 'outgoing' : 'incoming'"
                          [title]="(event.isOutgoing ? 'Call.Outgoing' : 'Call.Incoming') | i18next">
                        {{ event.isOutgoing ? '\u2197' : '\u2199' }}
                    </span>
                    {{ event.deviceName ?? "" | i18next }}
                </div>
                <div class="call-event-datetime">
                    {{ event.timestamp * 1000 | date : "longDate" }} &middot; {{ event.timestamp * 1000 | date : "HH:mm" }}
                    <ng-container *ngIf="{ period: getTimePeriod(event.timestamp) } as ctx">
                        <span class="time-period-chip" [ngClass]="'chip--' + ctx.period">
                            {{ timePeriodKeys[ctx.period] | i18next }}
                        </span>
                    </ng-container>
                </div>
            </div>
        </div>
        <div class="call-event-preview-image"
             *ngIf="event.images_urls && event.images_urls.length > 0"
             [class.fade-out]="expandedEventId === event.id">
            <img [src]="event.thumbnail_url || event.images_urls[0]" alt="">
        </div>
    </div>

    <div *ngIf="expandedEventId === event.id && event.images_urls && event.images_urls.length > 0"
         [@slideToggle]
         class="call-event-all-images">
        <div class="all-images">
            <div *ngFor="let imageUrl of event.images_urls" class="image-item"
                 (mouseenter)="onImageHover($event, imageUrl)"
                 (mouseleave)="onImageLeave()">
                <img [src]="imageUrl" alt="">
            </div>
        </div>
    </div>
</div>

<dx-tooltip #imageTooltip
    position="top"
    [showEvent]="undefined"
    [hideEvent]="undefined"
    [hideOnOutsideClick]="true"
    [wrapperAttr]="{ class: 'call-event-image-tooltip' }"
    [animation]="{ show: { type: 'fade', duration: 400 }, hide: { type: 'fade', duration: 0 } }">
    <div *dxTemplate="let data of 'content'" class="tooltip-image-wrapper">
        <img *ngIf="hoveredImageUrl" [src]="hoveredImageUrl" alt="">
    </div>
</dx-tooltip>
